import React from 'react';

//types
import { IIconProps } from 'assets/icons/IconProps';

export const PencilIcon = ({
  width = 24,
  height = 24,
  stroke = '#A0A4A8',
  strokeWidth = 2,
}: IIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={strokeWidth}
      d="M12 20h9M16.5 3.5c.398-.398.937-.621 1.5-.621.279 0 .554.055.812.161.257.107.491.263.688.46.197.197.353.431.46.688.107.258.161.534.161.812 0 .279-.054.555-.161.812-.107.257-.263.491-.46.688L7 19l-4 1 1-4L16.5 3.5z"
    />
  </svg>
);
